import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonBar, SectionDescription } from '../../components';

const sections = [
  {
    title: 'Verify Personal Info',
    description: 'Confirm your name, date of birth, address, and contact details'
  },
  {
    title: 'Residence',
    description: 'Your primary residence and legal jurisdiction'
  },
  {
    title: 'Assets',
    description: 'Property, accounts, and belongings to distribute'
  },
  {
    title: 'Beneficiaries',
    description: 'Who will inherit your assets and in what proportions'
  },
  {
    title: 'Executors',
    description: 'Appoint executors to manage your estate after your passing'
  },
  {
    title: 'Verify Personal Info',
    description: 'Confirm your name, date of birth, and contact details'
  }
];

export function NewWillIntroScreen() {
  const navigate = useNavigate();

  const handleCancel = useCallback(() => {
    navigate('/home');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('verify');
  }, [ navigate ]);

  return (
    <div className="new-will-intro-screen screen-container">
      <div className="screen-header">
        <h2>What we'll cover</h2>
      </div>
      <div className="section-overview">
        <p>
          This guided process will help you create a legally valid will in just a few simple steps.
          This process can be completed in multiple sessions.
        </p>
      </div>
      {sections.map((section, index) => (
        <SectionDescription key={index} title={section.title} description={section.description} />
      ))}
      <ButtonBar 
        handlePrimary={handleNext}
        handleSecondary={handleCancel}
        primaryText="Get Started"
        secondaryText="Cancel"
      />
    </div>
  );
}


